import { Link } from "react-router-dom";
import TableActionMenu from "../../../components/table-action-menu/table-action-menu";

const ContactColumns = (navigate) => {
  return [
  {
    dataKey: "contactID",
    name: "ID",
    width: "80px",
    minWidth: "80px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "name", // Updated dataKey
    name: "Name",
    width: "300px",
    minWidth: "300px",
    align: "left",
    sortAccessor: (rowData) =>
      `${rowData.firstName ?? ""} ${rowData.lastName ?? ""}`.trim(),
    render: (value, rowData) => {
      const fullName = `${rowData.firstName} ${rowData.lastName}`;
      return (
        <Link
          style={{ color: "inherit" }}
          to={`/contactsview/${rowData.contactID}/details`}
        >
          {fullName}
        </Link>
      );
    },
    sortable: true,
  },
  {
    dataKey: "title",
    name: "Title",
    width: "200px",
    minWidth: "200px",
    align: "left",
    // sortable: true,
  },
  {
    dataKey: "type",
    name: "Type",
    width: "100px",
    minWidth: "100px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "companyName",
    name: "Company",
    width: "300px",
    minWidth: "300px",
    align: "left",
    sortable: true,
    render: (value, rowData) => {
      return (
        <Link
          style={{ color: "inherit", textDecoration: "underline" }}
          to={`/companiesview/${rowData.companyID}/details`}
        >
          {value}
        </Link>
      );
    },
  },
  {
    dataKey: "dateCreated",
    name: "Created (mm/dd/yyyy)",
    width: "100px",
    minWidth: "100px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "contactState",
    name: "State",
    width: "100px",
    minWidth: "100px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "emailAddress",
    name: "Email",
    width: "300px",
    minWidth: "300px",
    align: "left",
    // sortable: true,
  },
  {
    dataKey: "phoneNumber",
    name: "Phone",
    width: "150px",
    minWidth: "150px",
    align: "left",
    // sortable: true,
  },
  {
    name: "",
    dataKey: "actions",
    width: "10px",
    minWidth: "10px",
    align: "center",
    render: (cellData, rowData) => {
      return (
        <TableActionMenu
        options={[
          {
            title: `View Contact Page`,
            onClick: () => {
              navigate(`/contactsview/${rowData.contactID}/details`);
            },
          },
          {
            title: `View Company Page`,
            onClick: () => {
              navigate(`/companiesview/${rowData.companyID}/details`);
            },
          },
        ]}
        noBorder
      />
      );
    },
  },
]}

export default ContactColumns;
